import { useCallback, useMemo } from 'react';
import { useStatePiece } from 'react-pieceful-state';

const useSharedObject = <T extends object>(base: string, initial: T, region = 'editAsset') => {
  const [value, setValue, resetValue] = useStatePiece<T>(base, initial, region);

  const setVal = useCallback((v) => setValue((state) => ({ ...state, ...v })), []);

  return useMemo(() => [value, setVal, resetValue] as const, [value, setVal, resetValue]);
};

export default useSharedObject;
